import { createAPI } from '@common'
export default {
  getMamPhotoDetail: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0qipup0efubjm', 'GET', config),
  postMamPhotoDetail: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0qipup0efubjm', 'POST', config), // 图片基础信息修改
  // 列表删除
  deleteMamImageDelete: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0qipup0efmfuf', 'DELETE', config),
  // 预览和详情页的删除
  deleteMamImageDeleteSingle: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0qipup0efmfuf0tjohmf', 'DELETE', config),
  // 获取视频编目信息
  getMamPhotoDetailCatalog: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0qipup0efubjm0dbubmph', 'GET', config),
  // 组图修改名称
  putMamPhotoGroup: (config) => createAPI('customEncryptApiName-1/0w20nbn0qipup0hspvq', 'PUT', config),
  // 组图拖拽排序
  putMamPhotoGroupSort: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0qipup0hspvq0tpsu', 'PUT', config, {
      neverLoading: true
    }),
  // 编目基础信息查询
  getMamPhotoExtfields: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0qipup0fyugjfmet', 'GET', config),
  // 编目信息修改
  postMamPhotoExtfields: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0qipup0fyugjfmet', 'POST', config),
  // 编目信息修改
  postMamPhotoExtfieldsSynchronization: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0qipup0fyugjfmet0tzodispoj{bujpo', 'POST', config),
  // 图片基础信息修改
  postMamPhotoEdit: (config) => createAPI('customEncryptApiName-1/0w20nbn0qipup0feju', 'POST', config),
  postMamPhotoDownload: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0qipup0epxompbe', 'POST', config),
  // 移动图片
  postMamPhotoMove: (config) => createAPI('customEncryptApiName-1/0w20nbn0qipup0npwf', 'POST', config),
  // 判断分组操作的权限
  getMamPhotoGroupActions: (config) =>
    createAPI('customEncryptApiName-1/0w20nbn0qipup0hspvq0bdujpot', 'GET', config)
}
